export const AccessLevel = {
  NONE: "none",
  VIEW: "view",
  EDIT: "edit",
} as const

export type AccessLevelType = typeof AccessLevel[keyof typeof AccessLevel]

export interface UserPermissions {
  patients: AccessLevelType
  visits: AccessLevelType
  inventory: AccessLevelType
  outreach: AccessLevelType
  admin: boolean
}

export interface User {
  id: string
  email: string
  firstName: string
  lastName: string
  role: string
  title?: string // Dr., Prof., etc.
  specialization?: string // e.g., Pediatrician, General Practitioner
  permissions: UserPermissions
}

export interface UserFormData extends Omit<User, 'id'> {
  password?: string // Optional for editing
}
